'use strict';

function rrggbbaa(hexColor, opacity) {
    var intValue = Math.round(opacity * 255);
    var hexValue = intValue.toString(16).padStart(2, '0');
    return ("" + hexColor + hexValue).toUpperCase();
}

exports.rrggbbaa = rrggbbaa;
